import { medigapStateData } from '@components/seo/medsup/data/msStateData';
import BestMedSupIndex from '../../components/seo/medsup/BestMedSupIndex';

const MedSupIndex = ({ stateList }) => <BestMedSupIndex stateList={stateList} />;

export async function getServerSideProps() {
  return {
    props: {
      stateList: medigapStateData,
    },
  };
}

export default MedSupIndex;
